import React from 'react';
import { EyeIcon, CheckCircleIcon, ClockIcon, BookOpenIcon, CalendarIcon } from 'lucide-react';
const HeaderGlp6Tips = () => {
  return <header className="bg-white" style={{
    fontFamily: 'Georgia, Cambria, "Times New Roman", serif'
  }} data-id="element-5874">
      {/* Top black bar */}
      <div className="bg-black h-3 w-full" data-id="element-5875"></div>

      {/* Masthead section */}
      <div className="border-b border-gray-800 px-4 sm:px-6 py-4 sm:py-6" data-id="element-5876">
        <div className="text-center pb-3 sm:pb-4 mb-3 sm:mb-4" data-id="element-5877">
          <h2 className="font-serif text-2xl sm:text-3xl font-bold tracking-tight text-gray-900" data-id="element-5878">
            TRADITIONAL MEDPUB
          </h2>
          <div className="text-xs uppercase tracking-widest text-gray-500 mt-2 font-medium" data-id="element-5879">
            INDEPENDENT HEALTH INVESTIGATIONS SINCE 1982
          </div>
        </div>

        <div className="flex flex-col sm:grid sm:grid-cols-3 text-xs text-gray-600 border-b border-gray-300 pb-2 gap-1 sm:gap-0" data-id="element-5880">
          <div className="text-left" data-id="element-5881">VOL. 128, NO. 43</div>
          <div className="text-left sm:text-center" data-id="element-5882">
            {(() => {
            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            return yesterday.toLocaleDateString('en-US', {
              weekday: 'long',
              month: 'long',
              day: 'numeric',
              year: 'numeric'
            }).toUpperCase();
          })()}
          </div>
          <div className="text-left sm:text-right" data-id="element-5883">
            HEALTH & WELLNESS SECTION
          </div>
        </div>
      </div>

      {/* Article header */}
      <div className="px-4 sm:px-6 py-6 border-b border-gray-200" data-id="element-5884">
        <div className="max-w-4xl mx-auto" data-id="element-5885">
          <div className="uppercase text-xs tracking-wider text-gray-500 font-medium border-b border-gray-200 pb-2 mb-4" data-id="element-5886">
            PERSONAL REPORT
          </div>

          <h1 className="font-serif text-2xl sm:text-4xl font-bold text-gray-900 leading-tight mb-2" data-id="element-5887">
            6 Things I Wish Someone Told Me Before Starting Semaglutide
          </h1>
          <p className="text-base sm:text-lg text-gray-600 italic mb-5" data-id="element-5888">
            (From a Former Nurse Who Lost Everything on GLP-1s—Then Found Her
            Way Back)
          </p>

          <div className="flex items-start mb-5 border-b border-gray-200 pb-5" data-id="element-5889">
            <div className="w-14 h-14 overflow-hidden rounded-full flex-shrink-0 mr-4 border border-gray-300" data-id="element-5890">
              <img src="https://cdn.magicpatterns.com/uploads/qo1VVrn8u2FTESbwCETPV1/1.jpg" alt="Dr. Tom Parham" className="w-full h-full object-cover" data-id="element-5891" />
            </div>
            <div className="flex-1" data-id="element-5892">
              <div className="flex items-center" data-id="element-5893">
                <div className="font-medium text-gray-900 text-lg" data-id="element-5894">
                  By Patricia Morrison, RN, CN
                </div>
                <div className="ml-2 flex items-center text-blue-600" data-id="element-5895">
                  <CheckCircleIcon className="h-4 w-4" data-id="element-5896" />
                  <span className="text-xs ml-1 font-medium" data-id="element-5897">Verified</span>
                </div>
              </div>
              <div className="text-sm text-gray-600 mb-2" data-id="element-5898">
                Chicago, IL • Former Medical Practitioner • 58 Years Old • 4
                Years on GLP-1 Medications
              </div>
              <div className="flex text-xs text-gray-500 items-center" data-id="element-5899">
                <div className="flex items-center mr-4" data-id="element-5900">
                  <ClockIcon className="h-3 w-3 mr-1" data-id="element-5901" />
                  <span data-id="element-5902">18 min read</span>
                </div>
                <div className="flex items-center" data-id="element-5903">
                  <EyeIcon className="h-3 w-3 mr-1" data-id="element-5904" />
                  <span data-id="element-5905">42,372 views</span>
                </div>
              </div>
            </div>
          </div>

          <div className="my-4" data-id="element-5906">
            <img src="https://cdn.magicpatterns.com/uploads/nwn6hondxNojcsAjvGQfEj/2.png" alt="Before and after transformation" className="w-full rounded-lg shadow-lg mb-3" data-id="element-5907" />
            <div className="flex justify-between items-center px-2 py-1 bg-gray-50 rounded border-t border-gray-200" data-id="element-5908">
              <span className="text-xs font-medium text-gray-500 uppercase tracking-wide" data-id="element-5909">
                September 25, 2021
              </span>
              <span className="text-xs font-medium text-gray-500 uppercase tracking-wide" data-id="element-5910">
                December 7, 2025
              </span>
            </div>
          </div>

          <div className="my-4 border-l-4 border-gray-800 pl-6 py-4 bg-gradient-to-r from-gray-100 to-white shadow-sm" data-id="element-5911">
            <p className="text-sm uppercase tracking-wide text-gray-500 mb-2 font-semibold" data-id="element-5912">
              ARTICLE SUMMARY
            </p>
            <p className="text-base leading-relaxed text-gray-800 font-serif italic" data-id="element-5913">
              "What a Chicago nurse discovered after three years of crushing
              depression on semaglutide:
            </p>
            <p className="text-base leading-relaxed text-gray-800 font-serif italic mt-4" data-id="element-5914">
              6 science-backed strategies that address nausea, hair loss,
              fatigue, and the devastating 'flat feeling' without stopping your
              medication....
            </p>
            <p className="text-base leading-relaxed text-gray-800 font-serif italic mt-4" data-id="element-5915">
              — now helping 120+ GLP-1 users monthly at her weight loss clinic."
            </p>
          </div>

          <div className="border-t border-gray-200 pt-3 text-xs text-gray-500 flex flex-wrap justify-between" data-id="element-5916">
            <div className="mb-1 flex items-center" data-id="element-5917">
              <span className="font-medium mr-2" data-id="element-5918">Published by:</span>
              Traditional Medicine Publications
            </div>
            <div className="mb-1 flex items-center" data-id="element-5919">
              <span className="font-medium mr-2" data-id="element-5920">Published:</span>
              {(() => {
              const yesterday = new Date();
              yesterday.setDate(yesterday.getDate() - 1);
              return yesterday.toLocaleDateString('en-US', {
                month: 'long',
                year: 'numeric'
              });
            })()}
            </div>
          </div>
        </div>
      </div>
    </header>;
};
export default HeaderGlp6Tips;